import React, { useState } from 'react'

import { Box, Button, Typography } from '@material-ui/core'
import { useHistory } from 'react-router-dom'
import { reverse } from 'named-urls'

import { BaseDialog, MenuButton, Permitted } from 'components'

import constants from 'constants/index'
import { routes } from 'Routes'
import * as service from 'service'
import helpers from 'helpers'
import useSnackbar from 'hooks/useSnackbar'

const ActionButtons = ({ monitoringManagementKpi, refresh }) => {
  const [destroyOpen, setDestroyOpen] = useState(false)

  const history = useHistory()
  const snackbar = useSnackbar()

  const redirectToEdit = () =>
    history.push(
      reverse(routes.kpi.edit, {
        monitoringManagementKpiId: monitoringManagementKpi?.id,
      }),
    )

  const redirectToShow = () =>
    history.push(
      reverse(routes.kpi.show, {
        monitoringManagementKpiId: monitoringManagementKpi?.id,
      }),
    )

  const handleDestroy = async () => {
    try {
      await service.dponet.monitoringManagementKpi.destroy({
        monitoringManagementKpiId: monitoringManagementKpi?.id,
      })
      setDestroyOpen(false)
      refresh()
      snackbar.open({
        message: 'KPI excluído com sucesso.',
        variant: 'success',
      })
    } catch (error) {
      snackbar.open({
        message:
          helpers.formatters.errorMessage(error?.response?.data?.error) ||
          'Erro ao excluir KPI.',
        variant: 'error',
      })
    }
  }

  return (
    <>
      <Box display="flex" justifyContent="flex-end">
        <MenuButton>
          <Permitted
            tag={constants.permissions.MONITORING_MANAGEMENT_KPI.MANAGE}
          >
            <Button color="secondary" fullWidth onClick={redirectToEdit}>
              Editar
            </Button>
            <Button
              color="secondary"
              fullWidth
              onClick={() => setDestroyOpen(true)}
            >
              Excluir
            </Button>
          </Permitted>
          <Button color="secondary" fullWidth onClick={redirectToShow}>
            Visualizar
          </Button>
        </MenuButton>
      </Box>
      <BaseDialog
        open={destroyOpen}
        setOpen={setDestroyOpen}
        title="Excluir KPI"
        closeButtonText="Cancelar"
        actionButtonText="Excluir"
        actionButton={handleDestroy}
        dialogSize="sm"
        justifyActions="flex-end"
        fullWidth
      >
        <Box py={2}>
          <Typography variant="subtitle1">
            Tem certeza que deseja excluir o KPI{' '}
            <strong>{monitoringManagementKpi?.name}</strong>? Todas as medidas
            vinculadas também serão excluídas. Esta ação não pode ser desfeita.
          </Typography>
        </Box>
      </BaseDialog>
    </>
  )
}

export default ActionButtons
